/* 🤖 this file was generated by svg-to-ts */
export const matIconKeyboardCapslock: {
  name: 'keyboard-capslock';
  data: string;
} = {
  name: 'keyboard-capslock',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12 8.41 16.59 13 18 11.59l-6-6-6 6L7.41 13 12 8.41zM6 18h12v-2H6v2z"/></svg>`
};
